// extracted by mini-css-extract-plugin
module.exports = {"Heading":"BnsF4","Heading__Image":"mkWi3","Heading__Title":"Db1Uw"};